import React, { useRef, useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { motion, AnimatePresence } from 'framer-motion';
import Sun from '../../macadamia-core/icons/Sun';
import Moon from '../../macadamia-core/icons/Moon';
import Window from '../../macadamia-core/icons/Window';

const ThemeSelector = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { isDarkMode, isSystemTheme, toggleThemeMode } = useTheme();
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleModeChange = (mode: 'light' | 'dark' | 'system') => {
        toggleThemeMode(mode);
        setIsOpen(false);
    };

    const iconProps = {
        width: "20px",
        height: "20px"
    };

    const icons = {
        light: () => <Sun {...iconProps} />,
        dark: () => <Moon {...iconProps} />,
        system: () => <Window {...iconProps} />
    };

    const getIcon = () => {
        if (isSystemTheme) {
            return icons.system();
        }
        return isDarkMode ? icons.dark() : icons.light();
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 rounded-full hover:bg-mcdm-primary-200 dark:hover:bg-mcdm-third-300 
             text-mcdm-third-500 dark:text-mcdm-secondary-400
             transition-colors duration-200"
                aria-label="Theme selector"
            >
                {getIcon()}
            </button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.2 }}
                        className="absolute right-0 mt-2 w-64 bg-white dark:bg-mcdm-third-400 shadow-sm dark:shadow-sm shadow-inner dark:shadow-inner
                       rounded-lg shadow-lg py-2 z-20"
                    >
                        <div className="px-4 py-2 text-sm font-medium text-mcdm-third-500 
                          dark:text-mcdm-primary-200">
                            Mode
                        </div>
                        <div className="px-2">
                            {[
                                { mode: 'light', label: 'Clair', Icon: Sun },
                                { mode: 'dark', label: 'Sombre', Icon: Moon },
                                { mode: 'system', label: 'Système', Icon: Window }
                            ].map(({ mode, label, Icon }) => (
                                <button
                                    key={mode}
                                    onClick={() => handleModeChange(mode as 'light' | 'dark' | 'system')}
                                    className={`w-full flex items-center px-3 py-2 text-sm rounded-md
                             ${(isSystemTheme && mode === 'system') ||
                                            (!isSystemTheme && ((isDarkMode && mode === 'dark') ||
                                                (!isDarkMode && mode === 'light')))
                                            ? 'bg-mcdm-primary-200 dark:bg-mcdm-third-300 text-mcdm-third-500 dark:text-mcdm-primary-200'
                                            : 'text-mcdm-third-500 dark:text-mcdm-primary-200 hover:bg-gray-100 dark:hover:bg-mcdm-third-300'
                                        }`}
                                >
                                    <div className="w-4 h-4 mr-3 flex items-center justify-center">
                                        <Icon
                                            width="16px"
                                            height="16px"
                                        />
                                    </div>
                                    {label}
                                </button>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ThemeSelector;